import { create } from 'zustand';

interface ErrorState {
  isFatalError: boolean;
  isModuleLocked: boolean;

  setFatalError: (value: boolean) => void;
  setModuleLocked: (value: boolean) => void;
}

export const useErrorStore = create<ErrorState>((set) => ({
  isFatalError: false,
  isModuleLocked: false,

  setFatalError: (value) => set({ isFatalError: value }),
  setModuleLocked: (value) => set({ isModuleLocked: value }),
}));
